import {PuppetType} from "../GameObjects/PuppetType";
import {PuppetGameButton} from "./PuppetGameButton";

export class PuppetTypeButton extends PuppetGameButton {

    public readonly puppetType: PuppetType;

    constructor(puppetType: PuppetType) {
        super();
        this.puppetType = puppetType;
        this._hoverVO = `andy_0${3 + puppetType}`;
    }
}
